import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Squares from '../Squares/Squares';
import leaf from "../../assets/Projects/chatify.png";


function Projects() {
  return (
    <div className="project-page" style={{ position: "relative", overflow: "hidden", background: "#1a1a1a" }}>
    <Container fluid className="project-section">
{/* Animated background */}
      <div className="background-animation">
        <Squares
          speed={0.5}
          squareSize={40}
          direction='diagonal'
          borderColor='rgba(0, 153, 112, 0.15)'
          hoverFillColor='rgba(0, 153, 112, 0.1)'
        />
      </div>      <Container>
        <h1 className="project-heading" style={{textAlign: "center"}}>
          My Recent Works 
        </h1>
        <p style={{ color: "white", textAlign: "center" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Random Name API"
              description="An API/tool that creates random names starting with letters you choose. It gives you names from different cultures with their meanings and origins. Great for building apps, testing, learning about different cultures, or just having fun!"
              ghLink="https://github.com/ZannyM/Random_NameAPI"
              demoLink="https://random-nameapi.onrender.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Sustainable Waste Management API"
              description="A Spring Boot RESTful API that helps manage waste efficiently. It allows users to handle waste categories, recycling tips, and disposal guidelines, promoting eco-friendly practices for a cleaner planet."
              ghLink="https://github.com/ZannyM/SustainableWasteManagementAPI"
              demoLink="https://sustainablewastemanagementapi.onrender.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="My_Portfolio"
              description="Welcome to my personal portfolio website! This project highlights my journey as a Software Developer, showcasing my skills, work experience, and projects in a sleek, interactive, and responsive format."
              ghLink="https://github.com/ZannyM/My_Portfolio"
              // demoLink="#"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Coming Soon!"
              description="Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis."
              ghLink="https://github.com/ZannyM/FARMSHARP"
              // demoLink="#"              
            />
          </Col>
        

        </Row>
      </Container>
    </Container>
    </div>
  );
}

export default Projects;